/**
 * Variant constants for the PostThreadConnector component
 */
export const POST_THREAD_CONNECTOR_VARIANTS = {
  REGULAR: 'regular',
  LAST: 'last',
  DIALOG_REPLY: 'dialog-reply',
} as const;
